import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding-top: 10px;
  font-size: 14px;
  line-height: 1.5;
  margin-left: 20px;
  overflow-x: auto;
  gap: 28px;
`;

export const DetailSection = styled(Wrapper)`
  padding-top: 20px;
  padding-bottom: 10px;
`;

export const DetailWrapper = styled.div`
  max-height: 450px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`;

export const Toggle = styled.div`
  cursor: pointer;
  user-select: none;
  padding-bottom: 10px;
  padding-left: 10px;
  color: #096dd9;
  font-weight: 200;
`;

export const SecondarySummaryTable = styled.table`
  margin: 0 100px 40px 100px;
  table-layout: fixed;
  th {
    border-bottom: 1px solid black;
    padding-bottom: 8px;
    color: #4b4b4b;
  }
  td {
    padding-top: 12px;
    padding-bottom: 12px;
    color: #686868;
    vertical-align: top;
  }
  .value {
    font-weight: 600;
    text-align: right;
    padding-left: 12px;
  }
`;


